export const GATEKEEPER_TOGGLES = {
    DEBUG_ENABLED: 'Debug_enabled',
    REMOVE_USER_ACCESS_FROM_ACCOUNT_ENABLED: 'REMOVE_USER_FROM_ACCOUNT_NEW_FLOW',
    MVP_TWO_TOGGLE_ENABLED: 'MVP_TWO_TOGGLE',
    MVP_TWO_TOGGLE_PUBLIC_PAGES_ENABLED: 'MVP_TWO_TOGGLE_PUBLIC_PAGES',
    MULTI_ACCOUNT_FLOW_ENABLED: 'MULTI_ACCOUNT',
};
